export default "__VITE_ASSET__BiCa9_0Y__"